export const SAFE_AREA_INSET_BOTTOM = 'env(safe-area-inset-bottom, 0px)'

export const calcWithSafeAreaBottom = (baseValue: string | number): string => {
  const parsedValue = typeof baseValue === 'number' ? `${baseValue}px` : baseValue
  return `calc(${parsedValue} + ${SAFE_AREA_INSET_BOTTOM})`
}
